<template>
  <div>
    <b-row
      align-v="center"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="PeakAUCFitGraphBool"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="PeakAUCFitGraphBool.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="SinglePeakFitGraphExpanded=!SinglePeakFitGraphExpanded"
        >
          <b-icon
            v-if="SinglePeakFitGraphExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="PeakAUCFitGraphBool.value">
      <b-collapse
        v-model="SinglePeakFitGraphExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <TextInputConfiguration
          :controller="CenterPeakAUCCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <TextInputConfiguration
          :controller="WindowPeakAUCCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <CheckBoxConfiguration
          :controller="ReversePeakAUCCtrller"
          :switchprop="true"
        />
        <CheckBoxConfiguration
          :controller="StandardAdditionCtrller"
          :switchprop="true"
        />
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
        <StatisticalEvaluation
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller,inputTextConfCtrller} from '@/assets/classes/configuration.js'
import FitSelection from './model/FitSelection'
import StatisticalEvaluation from './StatisticalEvaluation'
import { mapGetters } from 'vuex'

const fitName = 'peakAUC'
const rootContextFolder='ReportViewer/Fit/' + fitName

export default {
  name: 'PeakAUCFit',
  components:{
    FitSelection,
    StatisticalEvaluation,
    CheckBoxConfiguration,
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      fitName,
      elementsConfig:[],
      PeakAUCFitGraphBool:new checkBoxGraphConfCtrller(`{0}.${ConfigName.PeakAUCFitDiscreteGraph}`,'Peak AUC Fit',false,rootContextFolder+'Enable',true),
      CenterPeakAUCCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.center`,'Center','Please give a numerical value','1',(value)=>{return !isNaN(value)&& value!==''}),
      WindowPeakAUCCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.window`,'Window','Please give a numerical value greater than zero','2',(value)=>{return !isNaN(value) && value>0}),
      ReversePeakAUCCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.reverseScan`,'Reverse',false,rootContextFolder+'ReverseSingle'),
      StandardAdditionCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.StandardAddition`,'Standard Addition',false,rootContextFolder+'StandardAddition'),
			SinglePeakFitGraphExpanded:true
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.PeakAUCFitGraphBool,
      this.CenterPeakAUCCtrller,
      this.WindowPeakAUCCtrller,
      this.ReversePeakAUCCtrller,
			this.StandardAdditionCtrller,
    ]
    this.configureStudy()
    this.$watch(
      'PeakAUCFitGraphBool.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
  methods:{
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.PeakAUCFitGraphBool.formatKeyValue(this.sectionconfig)
      this.PeakAUCFitGraphBool.setParent(this)
      this.verifyConfiguration()
    },
    verifyConfiguration(){
      if(this.PeakAUCFitGraphBool.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
      }
    }
  }
}
</script>

<style>

</style>
